module.exports = __webpack_public_path__ + "img/TESL_Firebolt-rev2_art.9b1d2685.jpg";